__turbopack_context__.v({
  "bottomCircle": "new_hero_section-module-scss-module__gfEXEG__bottomCircle",
  "getStartedButton": "new_hero_section-module-scss-module__gfEXEG__getStartedButton",
  "heroSectionBackgroundContainer": "new_hero_section-module-scss-module__gfEXEG__heroSectionBackgroundContainer",
  "learnMoreButton": "new_hero_section-module-scss-module__gfEXEG__learnMoreButton",
  "topCircle": "new_hero_section-module-scss-module__gfEXEG__topCircle",
  "topCircleContent": "new_hero_section-module-scss-module__gfEXEG__topCircleContent",
  "topCircleContentContainer": "new_hero_section-module-scss-module__gfEXEG__topCircleContentContainer",
});
